import { AssetNetworkIcon, Typography } from '@libs/components';
import styled from 'styled-components';

type MobileUserAssetWrapperProps = {
  isLastElement?: boolean;
};
type AssetNetworkIconProps = {
  isAlone?: boolean;
};
type StickyContainerProps = {
  isAppDisclaimerVisible?: boolean;
};
export const MobileUserAssetWrapper = styled.div<MobileUserAssetWrapperProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.6rem 2.2rem 1.6rem 0;
  margin-left: 2.2rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borders.default};
  &:last-child {
    border-bottom: 1px solid
      ${({ isLastElement, theme }) =>
        isLastElement ? theme.colors.borders.default : 'transparent'};
  }
`;

export const MobileUserAssetRightComponentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
export const FlexCenter = styled.div`
  display: flex;
  align-items: center;
`;
export const CodeTypography = styled(Typography)`
  margin-left: 0.4rem;
`;
export const ArrowWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 0.4rem;
`;
export const CustomAssetNetworkIcon = styled(
  AssetNetworkIcon
)<AssetNetworkIconProps>`
  margin-right: 1.6rem;
  .baseNetworkIcon {
    width: ${({ isAlone }) => (isAlone ? '4.2rem' : '2.2rem ')};
    height: ${({ isAlone }) => (isAlone ? '4.2rem' : '2.2rem ')};
  }
  .networkIconWrapper {
    width: 2.2rem;
    height: 2.2rem;
    bottom: -1rem;
    right: -1.1rem;
    top: unset;
    padding: 0;
  }
`;
export const StickyContainer = styled.div<StickyContainerProps>`
  padding: 0.4rem 2.2rem;
  position: sticky;

  background-color: ${({ theme }) => theme.colors.surface.default};
  top: ${({ isAppDisclaimerVisible }) =>
    isAppDisclaimerVisible ? '14.5rem' : '8.3rem'};
  z-index: ${({ theme }) => theme.zIndex.medium};
`;
export const MobileTableWrapper = styled.div`
  display: block;
  ${({ theme }) => theme.media.laptop`
    display:none;
  `};
`;
